module.exports = __webpack_public_path__ + "img/20f7.f3a634ff.jpg";